// extracted by mini-css-extract-plugin
var _1 = "csGzcl2tkRzYoCzC4PxS";
var _2 = "smNhDK8nZpufevkSi1t3";
var _3 = "R2BOgqLAdpOWbNvET40w";
var _4 = "_4qkYw9o6IFbGG0vbKNwn";
export { _1 as "entry", _2 as "frame", _3 as "label", _4 as "value" }
